import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {ACNE_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/acne-teleconsultation/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/acne-teleconsultation/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/acne-teleconsultation/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/acne-teleconsultation/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/acne-teleconsultation/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/acne-teleconsultation/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/acne-teleconsultation/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/acne-teleconsultation/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/acne-teleconsultation/Questionnaire9Screen';
import Questionnaire10Screen from '~/pages/homes/acne-teleconsultation/Questionnaire10Screen';
import Questionnaire11Screen from '~/pages/homes/acne-teleconsultation/Questionnaire11Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const AcneTeleconsultation = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case ACNE_TELECONSULTATION_KEYS.START:
        trackPageViewGA('/acne-tel/start', 'MDQ-Acne Tel - Start');
        return <Questionnaire1Screen />;
      case ACNE_TELECONSULTATION_KEYS.PROFILE:
        trackPageViewGA('/acne-tel/profile', 'MDQ-Acne Tel - Profile');
        return <Questionnaire2Screen />;
      case ACNE_TELECONSULTATION_KEYS.INVALID:
        trackPageViewGA('/acne-tel/invalid', 'MDQ-Acne Tel - Invalid');
        return <Questionnaire3Screen />;
      case ACNE_TELECONSULTATION_KEYS.SKINCARE_GOALS:
        trackPageViewGA('/acne-tel/skincare-goals', 'MDQ-Acne Tel - Skincare Goals');
        return <Questionnaire4Screen />;
      case ACNE_TELECONSULTATION_KEYS.SKIN_TYPE:
        trackPageViewGA('/acne-tel/skin-type', 'MDQ-Acne Tel - Skin Type');
        return <Questionnaire5Screen />;
      case ACNE_TELECONSULTATION_KEYS.DESCRIBE_SKIN_CONDITION:
        trackPageViewGA('/acne-tel/describe-skin-condition', 'MDQ-Acne Tel - Describe Skin Condition');
        return <Questionnaire6Screen />;
      case ACNE_TELECONSULTATION_KEYS.PREGNANT_OR_BREASTFEEDING:
        trackPageViewGA('/acne-tel/pregnant-or-breastfeeding', 'MDQ-Acne Tel - Pregnant or Breastfeeding');
        return <Questionnaire7Screen />;
      case ACNE_TELECONSULTATION_KEYS.HAVE_SIDE_EFFECTS_OR_ALLERGIC:
        trackPageViewGA('/acne-tel/have-side-effects-or-allergic', 'MDQ-Acne Tel - Have Side Effects or Allergic');
        return <Questionnaire8Screen />;
      case ACNE_TELECONSULTATION_KEYS.ON_ACNE_OR_SKIN_TREATMENT:
        trackPageViewGA('/acne-tel/on-acne-or-skin-treatment', 'MDQ-Acne Tel - On Acne or Skin Treatment');
        return <Questionnaire9Screen />;
      case ACNE_TELECONSULTATION_KEYS.OTHER_MEDICATIONS_OR_SUPPLEMENTS:
        trackPageViewGA(
          '/acne-tel/other-medications-or-supplements',
          'MDQ-Acne Tel - Other Medications or Supplements',
        );
        return <Questionnaire10Screen />;
      case ACNE_TELECONSULTATION_KEYS.OTHER_CONDITION_OR_MEDICAL_HISTORY:
        trackPageViewGA(
          '/acne-tel/other-condition-or-medical-history',
          'MDQ-Acne Tel - Other Condition or Medical History',
        );
        return <Questionnaire11Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <NotFoundPage />;
    }
  };

  return renderQuestion();
};

export default AcneTeleconsultation;
